import { templates } from '@/mocks/home';

const templateImages: Record<string, string> = {
  '极简白': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20website%20navigation%20page%20design%20with%20white%20background%2C%20simple%20link%20cards%2C%20elegant%20typography%2C%20soft%20shadows%2C%20modern%20layout%2C%20editorial%20style%2C%20high%20quality%2C%20professional%20look&width=800&height=560&seq=template-minimal&orientation=landscape',
  '科技蓝': 'https://readdy.ai/api/search-image?query=Modern%20tech%20style%20navigation%20page%20with%20dark%20gradient%20background%2C%20neon%20link%20cards%2C%20futuristic%20design%2C%20glowing%20elements%2C%20clean%20layout%2C%20professional%20UI&width=800&height=560&seq=template-tech&orientation=landscape',
  '暖橙主题': 'https://readdy.ai/api/search-image?query=Warm%20orange%20themed%20navigation%20page%20design%20with%20soft%20gradient%20background%2C%20rounded%20link%20cards%2C%20friendly%20aesthetic%2C%20modern%20UI%2C%20clean%20layout%2C%20inviting%20color%20palette&width=800&height=560&seq=template-warm&orientation=landscape',
  '暗夜模式': 'https://readdy.ai/api/search-image?query=Dark%20mode%20navigation%20page%20design%20with%20deep%20charcoal%20background%2C%20glass%20morphism%20link%20cards%2C%20modern%20minimalist%20layout%2C%20professional%20dark%20theme&width=800&height=560&seq=template-dark&orientation=landscape',
};

export default function TemplatesSection() {
  return (
    <section id="templates" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            丰富的主题模板
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            多款精心设计的模板，一键切换，打造专属风格的导航页
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {templates.map((template) => (
            <div key={template.name} className="group rounded-xl overflow-hidden bg-background-100 cursor-pointer">
              <div className="relative w-full aspect-[4/2.8] overflow-hidden">
                <img
                  src={templateImages[template.name]}
                  alt={template.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>
              <div className="p-4">
                <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2.5 py-1 rounded-full">
                  {template.category}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-2.5">
                  {template.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}